import React, { useState, useEffect } from 'react';
import { DataGrid, Button } from 'devextreme-react';
import * as Fnctn from '../../contexts/GenericFunctions'
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader';
import { TagBoxSucursales, TagBoxAreas } from '../../components/ReportTasks/ReportTasks'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { CellRenderProgressBar } from '../../components/ReportTasks/ReportTasks'
import {
    Column,
    Export,
    ColumnChooser,
    ColumnFixing,
    Pager,
    MasterDetail,
    DataGridTypes,
    SearchPanel,
    HeaderFilter,
    Search
} from 'devextreme-react/data-grid';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ReportCourses_v2.scss';

function ReportCourses_v2() {
    const [codeSucursales, setCodeSucursales] = useState<any>();
    const [codeAreas, setCodeAreas] = useState<any>();
    const [dgvDatos, setDgvDatos] = useState<any>();
    const [visibleDgvDatos, setVisibleDgvDatos] = useState<boolean>(false);


    // const DetailTemplate = (props: any, dtDetail: any) => {
    //     const { data } = props.data;
    //     let DataGridDetail = dtDetail.data;
    //     const detailDataSource = DataGridDetail.filter((item: any) => item.cvetra === data.cvetra);
    //     return (
    //         <DataGrid
    //             dataSource={detailDataSource}
    //             showBorders={true}
    //             columnAutoWidth={true}
    //         >
    //             <Column dataField="course_name" caption="Nombre del Curso" />
    //             <Column dataField={"total_pending"} caption='Pendientes' key={Math.random()} visible={true} cellRender={(e) => CellRenderProgressBar(e, "Progress")} alignment='center' />
    //             <Column
    //                 dataField={"total_completed"}
    //                 caption='Completadas'
    //                 key={Math.random()}
    //                 visible={true}
    //                 cellRender={(e) => CellRenderProgressBar(e, "Progress")}
    //                 alignment='center'
    //             />
    //             <Column dataField="total_classes" caption="Total de clases" alignment='center' />
    //         </DataGrid>
    //     );
    // };

    const onExporting = (e: DataGridTypes.ExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Hoja 1');
        exportDataGrid({
            component: e.component,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Seguimiento_Cursos.xlsx`);
            });
        });
    };

    const transformData = (data: any[]) => {
        return data.map(item => {
            const base = {
                cvetra: item.cvetra,
                name_employee: item.name_employee,
                job_name: item.job_name,
                area: item.area,
                branch: item.branch
            };

            const cursos: any = {};

            Object.keys(item).forEach(key => {
                if (key.includes("--")) {
                    const [nombre, id] = key.split("--");

                    if (nombre === "Puntuacion") {
                        if (!cursos[id]) cursos[id] = {};
                        cursos[id].puntuacion = item[key];
                    } else {
                        if (!cursos[id]) cursos[id] = {};
                        cursos[id].nombre = nombre.replaceAll("_", " ");
                        cursos[id].progreso = item[key];
                    }
                }
            });

            // convertir a propiedades planas
            const cursosFlat: any = {};

            Object.values(cursos).forEach((c: any) => {
                const nombre = c.nombre.trim().replace(/\s+/g, " ");

                cursosFlat[nombre] = c.progreso;
                cursosFlat[`${nombre}_score`] = c.puntuacion;
            });

            return {
                ...base,
                ...cursosFlat
            };
        });
    };

    const generateColumns = (data: any[]) => {
        const keys = new Set<string>();

        data.forEach(row => {
            Object.keys(row).forEach(key => {
                if (
                    !["cvetra", "name_employee", "job_name", "area", "branch"].includes(key)
                ) {
                    keys.add(key);
                }
            });
        });

        return Array.from(keys).map(key => ({
            dataField: key,
            caption: key.replace("_score", " Puntuación"),
            alignment: "center",
            format: key.includes("score") ? { type: 'percent', precision: 2 } : undefined
        }));
    };

    const Consultar = async () => {
        halcoloaderActive();
        try {
            let ObjtEvaluations: any = {
                // "id_evaluacion": codeEvaluacion,
                "areas_id": codeAreas,
                "branches_id": codeSucursales
            };

            let dtresult: any = await Fnctn.postData(`/reports/get_user_result_courses`, "POST", ObjtEvaluations);
            dtresult = await dtresult.json();


            const transformed = transformData(dtresult.data);
            let data = transformed
            let columns = generateColumns(transformed)


            setDgvDatos(
                <DataGrid
                    className='dgvResultados'
                    dataSource={data}
                    height="650px"
                    width="100%"
                    rowAlternationEnabled={false}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    showBorders={true}
                    keyExpr="cvetra"
                    key={JSON.stringify(columns)}
                    onExporting={onExporting}
                >
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Pager showPageSizeSelector={true} allowedPageSizes={[100, 150, 'all']} />
                    <SearchPanel visible={true} width={240} placeholder="Search..." />
                    <HeaderFilter><Search enabled={true} /></HeaderFilter>
                    <ColumnChooser enabled={true} />
                    <ColumnFixing enabled={true} />
                    <Column dataField="cvetra" caption="No Empleado" />
                    <Column dataField="name_employee" caption="Nombre" />
                    <Column dataField="job_name" caption="Puesto" />
                    <Column dataField="area" caption="Area" />
                    <Column dataField="branch" caption="Sucursal" />
                    {columns.map((col: any) => (<Column key={col.dataField} {...col} />))}

                </DataGrid>
            );
            setVisibleDgvDatos(true);
        } catch (error) {
            console.error("Error al consultar los datos:", error);
        } finally {
            halcoloaderRemove();
        }
    };

    const getIds = (list: any, tb: string) => {
        if (tb === "sucursales") setCodeSucursales(list);
        else if (tb === "areas") setCodeAreas(list);
    }

    useEffect(() => {
    }, []);

    return (
        <React.Fragment>
            <div className={'content-block dx-card responsive-paddings'} style={{ margin: "30px 0px 30px 45px", width: "95%" }}>
                <div className='row'>
                    <div className='col-md-3'>
                        <TagBoxSucursales getIds={getIds}></TagBoxSucursales>
                    </div>
                    <div className='col-md-3'>
                        <TagBoxAreas getIds={getIds}></TagBoxAreas>
                    </div>
                    <div className='col-md-3'>
                        <Button
                            className='btnConsultar'
                            stylingMode='contained'
                            text='Consultar'
                            onClick={() => Consultar()}
                        ></Button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        {visibleDgvDatos && dgvDatos}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ReportCourses_v2;